import React, { memo, useContext } from 'react';
import parse from 'html-react-parser';
import './css/HomePage1About.css';
import { context } from '../../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../../catalog/Validity';
import { getHTMLTextFromNormalText } from '../../../../../catalog/Website';

const HomePage1About = () => {
    const { globalState } = useContext(context);

    return (
        <>
            {isValidObject(globalState.teamInfo) && isValidString(globalState.teamInfo.shortAbout) ? (
                <div className="homepage1-about-container full-width p-t-100px p-l-150px p-b-100px">
                    <div className="homepage1-about">
                        <p className="alegreya-font-family font-weight-800 font-size-5xl text-uppercase text-left-align m-t-0">About</p>
                        <div className="homepage1-about-text alegreya-font-family game-info1-text font-spacing-wider line-height-wider text-left-align m-t-0 m-b-0 font-size-l">
                            {parse(getHTMLTextFromNormalText(globalState.teamInfo.shortAbout))}
                        </div>

                    </div>
                    <img className="homepage1-about-icon x-center m-l-20px" src={globalState.logo.logo4} alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                </div>
            ) : null}
        </>
    );
};

export default memo(HomePage1About);
